// redux/globalproducts.jsx

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "../api/api"; // adjust this path if needed
import { Produts_Add } from "../api/urls";

// Thunk to fetch global products
export const fetchGlobalProducts = createAsyncThunk(
  "globalProducts/fetch",
  async () => {
    const response = await api.get(Produts_Add + `?biz=global`);
    return response.data;
  }
);

const globalProductsSlice = createSlice({
  name: "globalProducts",
  initialState: {
    items: [],
    loading: false,
    error: null,
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchGlobalProducts.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchGlobalProducts.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload;
      })
      .addCase(fetchGlobalProducts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message;
      });
  },
});

export default globalProductsSlice.reducer;
